import { ajaxAuth } from "@tm/utils"
import {
    SelectPaymentRequest,
    SetCustomOrderInformationRequest,
    SelectShipmentRequest,
    SelectBillingAddressRequest,
    SelectDeliveryAddressRequest,
    SetCustomOrderNumberRequest,
    SetOrderCommentRequest,
    SelectDeliveryDistributionRequest,
    SelectTourRequest,
    SetDeliveryDateRequest,
    SelectBillingModeRequest,
    SelectOrderProcessingRequest,
    SelectBackorderRequest,
    ShowDefaultWarehouseResponse,
    ShowDefaultWarehouseRequest,
    ShowWarehousesResponse,
    ShowWarehousesRequest,
    ShowItemsOptionVersionsRequest,
    ShowItemsOptionVersionsResponse,
    SelectOrderOptionsResponse,
    SetTourFilterDateRequest,
} from "@tm/models"
import { getBundleParams } from "../../../utils"

function getOrderOptionsUrl() {
    return getBundleParams().orderOptionsServiceUrl
}

function orderWarehousesEnabled() {
    return getBundleParams().orderWarehousesEnabled
}

export function selectBackorder(body: SelectBackorderRequest) {
    const url = `${getOrderOptionsUrl()}/SelectBackorder`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function selectBillingAddress(body: SelectBillingAddressRequest) {
    const url = `${getOrderOptionsUrl()}/SelectBillingAddress`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function selectBillingMode(body: SelectBillingModeRequest) {
    const url = `${getOrderOptionsUrl()}/SelectBillingMode`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function selectDeliveryAddress(body: SelectDeliveryAddressRequest) {
    const url = `${getOrderOptionsUrl()}/SelectDeliveryAddress`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function selectDeliveryDistribution(body: SelectDeliveryDistributionRequest) {
    const url = `${getOrderOptionsUrl()}/SelectDeliveryDistribution`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function selectPayment(body: SelectPaymentRequest) {
    const url = `${getOrderOptionsUrl()}/SelectPayment`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function selectShipment(body: SelectShipmentRequest) {
    const url = `${getOrderOptionsUrl()}/SelectShipment`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function selectTour(body: SelectTourRequest) {
    const url = `${getOrderOptionsUrl()}/SelectTour`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function selectOrderProcessing(body: SelectOrderProcessingRequest) {
    const url = `${getOrderOptionsUrl()}/SelectOrderProcessing`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function setCustomOrderInformation(body: SetCustomOrderInformationRequest) {
    const url = `${getOrderOptionsUrl()}/SetCustomOrderNumberAndComment`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function setCustomOrderNumber(body: SetCustomOrderNumberRequest) {
    const url = `${getOrderOptionsUrl()}/SetCustomOrderNumber`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function setDeliveryDate(body: SetDeliveryDateRequest) {
    const url = `${getOrderOptionsUrl()}/SetDeliveryDate`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function setTourFilterDate(body: SetTourFilterDateRequest) {
    const url = `${getOrderOptionsUrl()}/SetTourFilterDate`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function setOrderComment(body: SetOrderCommentRequest) {
    const url = `${getOrderOptionsUrl()}/SetOrderComment`

    return ajaxAuth<SelectOrderOptionsResponse>({ url, body, method: "POST" })
}

export function showDefaultWarehouse(body: ShowDefaultWarehouseRequest) {
    if (!orderWarehousesEnabled()) {
        return Promise.resolve({ hasErrors: false })
    }

    const url = `${getOrderOptionsUrl()}/ShowDefaultWarehouse`

    return ajaxAuth<ShowDefaultWarehouseResponse>({ url, body })
}

export function showWarehouses(body: ShowWarehousesRequest) {
    if (!orderWarehousesEnabled()) {
        return Promise.resolve({ orderWarehouses: [], hasErrors: false })
    }

    const url = `${getOrderOptionsUrl()}/ShowWarehouses`

    return ajaxAuth<ShowWarehousesResponse>({ url, body })
}

export function showItemOptionVersions(body: ShowItemsOptionVersionsRequest) {
    const url = `${getOrderOptionsUrl()}/ShowItemOptionVersions`

    return ajaxAuth<ShowItemsOptionVersionsResponse>({ url, body, method: "POST" })
}
